import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as images from "../../constants/Images";
import PropTypes from "prop-types";
import "./Header.css";
import Notifications from "../../components/Notifications/Notifications";
import { CircularProgressWithLabel } from "../../components/Knowledge/CreateKnowledge/UploadDocument";
import { useSelector } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Drawer, useMediaQuery, useTheme } from "@mui/material";

function Header(props) {
  const { progressStatus } = useSelector((state) => state.progReducer);
  const { progressStatusAudio } = useSelector(
    (state) => state.progReducerAudio
  );
  const { activeLink, isInterestEmpty, interestLength } = props;
  const emptyLink = "#";

  const [notificationCount, setNotificationCount] = useState(0);
  const [show, setShow] = useState(false);
  // const [open, setOpen] = useState(false);

  // const [openPanel, setOpenPanel] = useState(false);
  //const OneSignal = window.OneSignal;

  // socket.socket.on("notificationBroadcast", (data) => {
  //   let res = Decrypt(data.data);
  //   console.log(res);
  // });

  // window.OneSignal.push(() => {
  //   window.OneSignal.on("notificationDisplay", function (event) {
  //     console.log("OneSignal notification displayed:", event);
  //   });
  //   //  window.OneSignal.log.setLevel("trace");
  // });
  // OneSignal.on([
  //   "addListenerForNotificationOpened",
  //   function (data) {
  //     console.log("Received NotificationOpened:");
  //     console.log(data);
  //   },
  // ]);

  // OneSignal.addEventListener("received", (notification) => {
  //   console.log("Notification received: ", notification);
  // });
  // console.log(interestLength)

  // const openModal = () =>{
  //   setOpen(true)
  //   console.log('-------------------------',open)
  // }

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const theme = useTheme();
    // Define different drawer widths for different breakpoints
    const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));
    const isSmall = useMediaQuery(theme.breakpoints.only('sm'));
    const isMedium = useMediaQuery(theme.breakpoints.only('md'));
    const isLarge = useMediaQuery(theme.breakpoints.only('lg'));
    const isExtraLarge = useMediaQuery(theme.breakpoints.up('xl'));

    let drawerWidth;

    // Set drawer width based on screen size
    if (isExtraSmall) {
      drawerWidth = '100%';
    } else if (isSmall) {
      drawerWidth = 280; // Width for small screens
    } else if (isMedium) {
      drawerWidth = 500; // Width for medium screens
    } else if (isLarge) {
      drawerWidth = 500; // Width for large screens
    } else if (isExtraLarge) {
      drawerWidth = 500; // Width for extra large screens
    }

  return (
    <div>
      <nav
        id={props.isOpen ? "header" : "miniheader"}
        className=" navbar navbar-expand-lg  fixed-top"
      >
        <div className="container-fluid">
          <div>
            {/* <img
              src={images.toggle_btn}
              className="navbar-brand header-toggle"
              // onClick={props.toggle}
            /> */}
            <img
              src={images.mahindralogored}
              className="navbar-brand header-mahindralogo"
            />
          </div>
          <ul className="header-nav navbar-nav">
            <li className="nav-item header-navitem">
              <Link
                to={
                  isInterestEmpty || interestLength ? "/knowledge" : emptyLink
                }
                id={activeLink == "knowledge" ? "active-link" : emptyLink}
                className="nav-link"
              >
                <img
                  src={
                    activeLink == "knowledge"
                      ? images.create_knowledge_active
                      : images.create_knowledge
                  }
                  className="header-navimg"
                />
                <span className="header-text">Knowledge Base</span>
              </Link>
            </li>
            <li className="nav-item header-navitem">
              <Link
                to={isInterestEmpty || interestLength ? "/home" : emptyLink}
                id={activeLink == "home" ? "active-link" : emptyLink}
                className="nav-link"
              >
                <img
                  src={activeLink == "home" ? images.home_active : images.home}
                  className="header-navimg"
                />
                <span className="header-text">My Feed</span>
              </Link>
            </li>
            <li className="nav-item header-navitem">
              <Link
                to={
                  isInterestEmpty || interestLength ? "/all-stories" : emptyLink
                }
                id={activeLink == "all_stories" ? "active-link" : emptyLink}
                className="nav-link"
              >
                <img
                  src={
                    activeLink == "all_stories"
                      ? images.ques_for_me_active
                      : images.ques_for_me
                  }
                  className="header-navimg"
                />
                <span className="header-text">All stories</span>
              </Link>
            </li>
            <li className="nav-item header-navitem">
              <Link
                to={
                  isInterestEmpty || interestLength
                    ? "/questions-for-me"
                    : emptyLink
                }
                id={
                  activeLink == "questions_for_me" ? "active-link" : emptyLink
                }
                className="nav-link"
              >
                <img
                  src={
                    activeLink == "questions_for_me"
                      ? images.ask_expert_active
                      : images.ask_expert
                  }
                  className="header-navimg"
                />
                <span className="header-text">Forum</span>
              </Link>
            </li>
            {/* <li className="nav-item header-navitem">
              <Link
                to="/create-knowledge"
                id={activeLink == "create_knowledge" ? "active-link" : emptyLink}
                className="nav-link"
              >
                <img
                  src={
                    activeLink == "create_knowledge"
                      ? images.create_knowledge_active
                      : images.create_knowledge
                  }
                  className="header-navimg"
                />
                <span className="header-text">Create Knowledge</span>
              </Link>
            </li> */}
            <li className="nav-item header-navitem">
              <Link
                to={isInterestEmpty || interestLength ? "/calendar" : emptyLink}
                id={activeLink == "calendar" ? "active-link" : emptyLink}
                className="nav-link"
              >
                <img
                  src={
                    activeLink == "calendar"
                      ? images.calender_active
                      : images.calender
                  }
                  className="header-navimg"
                />
                <span className="header-text">Calendar</span>
              </Link>
            </li>
            <li
              className="nav-item header-navitem"
              type="button"
              // data-bs-toggle="offcanvas"
              data-bs-target="#notificationsBar"
              onClick={handleShow}
            >
              <img src={images.notification} className="header-navimg" />
              {notificationCount != 0 && (
                <span className="position-absolute translate-middle badge rounded-pill bg-danger noti-badge">
                  {notificationCount}
                  <span className="visually-hidden">unread messages</span>
                </span>
              )}

              <span className="header-text">Notification</span>
            </li>
          </ul>

          <img
            src={images.mkisan_red}
            className="navbar-brand header-mkisanlogo"
          />
        </div>
        {/* {openPanel && (
        <div className="backdrop" onClick={() => setOpenPanel(false)}></div>
      )}
      <Notifications showNotification={openPanel} /> */}
      </nav>

      <React.Fragment>
        <Drawer
          open={show}
          onClose={handleClose}
          anchor={"right"}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
        >
          <div className="container">
            <div className="row justify-content-between p-2 mt-3 mb-5">
              <div className="col-2">
                <h5>Notifications</h5>
              </div>
              <div className="col-2">
                <button
                  type="button"
                  className="btn-close text-reset"
                  // data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  id="close-notification-button"
                  onClick={handleClose}
                ></button>
              </div>
            </div>
          </div>
          <div>
            {progressStatus ? (
              progressStatus !== 100 ? (
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography
                      sx={{ display: "inline-flex" }}
                      color="text.secondary"
                      gutterBottom
                    >
                      <h6>Uploading Video...</h6>
                      <CircularProgressWithLabel
                        style={{ marginLeft: "150px" }}
                        value={
                          Number.isNaN(progressStatus) ? 0 : progressStatus
                        }
                      />
                    </Typography>
                  </CardContent>
                </Card>
              ) : null
            ) : null}

            {progressStatusAudio ? (
              progressStatusAudio !== 100 ? (
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography
                      sx={{ display: "inline-flex" }}
                      color="text.secondary"
                      gutterBottom
                    >
                      <h6>Uploading Audio...</h6>
                      <CircularProgressWithLabel
                        style={{ marginLeft: "150px" }}
                        value={
                          Number.isNaN(progressStatusAudio)
                            ? 0
                            : progressStatusAudio
                        }
                      />
                    </Typography>
                  </CardContent>
                </Card>
              ) : null
            ) : null}
            <Notifications setCount={setNotificationCount} />
          </div>
        </Drawer>
      </React.Fragment>

      {/* <div
        id="notificationsBar"
        // className="offcanvas offcanvas-end"
        
        className="offcanvas offcanvas-end"
        // tabIndex="-1"
        //data-bs-backdrop="false"
        // aria-hidden="true"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">Notifications</h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"     
            aria-label="Close"
            id="close-notification-button"
          ></button>
        </div>
        <div className="offcanvas-body">
          {progressStatus ? (
            progressStatus !== 100 ? (
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography
                    sx={{ display: "inline-flex" }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <h6>Uploading Video...</h6>
                    <CircularProgressWithLabel
                      style={{ marginLeft: "150px" }}
                      value={Number.isNaN(progressStatus) ? 0 : progressStatus}
                    />
                  </Typography>
                </CardContent>
              </Card>
            ) : null
          ) : null}

          {progressStatusAudio ? (
            progressStatusAudio !== 100 ? (
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography
                    sx={{ display: "inline-flex" }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <h6>Uploading Audio...</h6>
                    <CircularProgressWithLabel
                      style={{ marginLeft: "150px" }}
                      value={
                        Number.isNaN(progressStatusAudio)
                          ? 0
                          : progressStatusAudio
                      }
                    />
                  </Typography>
                </CardContent>
              </Card>
            ) : null
          ) : null}
          <Notifications setCount={setNotificationCount} />
        </div>
      </div> */}
    </div>
  );
}

export default Header;

Header.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  activeLink: PropTypes.string,
  interestLength: PropTypes.number,
  isInterestEmpty: PropTypes.bool,
};
